import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import { CartContext } from "../context/CartContext";
import TopSelling from "../Components/TopSelling";
import { isAuthenticated } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../admin/api/api";
import { image_base_url } from "../admin/api/api";

const Cart = () => {
  const navigate = useNavigate();

  const { cartItems, increaseQty, decreaseQty, removeItem } =
    useContext(CartContext);

  const [shippingSetting, setShippingSetting] = useState(null);

  useEffect(() => {
    loadShippingSetting();
  }, []);

  const loadShippingSetting = async () => {
    try {
      const res = await api.get("/Settings/shipping");
      setShippingSetting(res.data);
    } catch (error) {
      console.error("Shipping API Error", error);
    }
  };

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const itemcount = cartItems.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  const shipping =
    shippingSetting && subtotal > shippingSetting.freeShippingAmount
      ? 0
      : shippingSetting?.standardCharge || 0;

  const remaining = shippingSetting
    ? shippingSetting.freeShippingAmount - subtotal
    : 0;

  const total = subtotal + shipping;

  // Checkout login check
  const handleCheckout = () => {
    if (!isAuthenticated()) {
      toast.warning("Please login to continue checkout");
      navigate("/login", { state: { from: "/checkout" } });
      return;
    }

    navigate("/checkout");
  };

  return (
    <>
      <Container className="my-5 pt-3">

        <Row style={{ borderBottom: "1px solid lightgray" }}>
          <Col md={12}>
            <h4 className="mb-4 fw-bold">Shopping Cart</h4>
          </Col>
        </Row>

        <Row>

          {/* LEFT SIDE CART ITEMS */}
          <Col md={9} className="mt-3">

            {cartItems.length === 0 ? (

              <div className="text-center py-5">
                <h4 className="mb-3">🛒 Your Cart is Empty</h4>
                <p className="text-muted">
                  Looks like you haven't added anything yet.
                </p>

                <Button
                  variant="dark"
                  onClick={() => navigate("/productlist")}
                >
                  Continue Shopping
                </Button>
              </div>

            ) : (

              cartItems.map((item) => (
                <Card key={item.id} className="cart-card mb-3">
                  <Row className="g-0 align-items-center">

                    <Col md={2} className="col-2">
                      <img
                        src={
                          item.image?.startsWith("http")
                            ? item.image
                            : `${image_base_url}${item.image}`
                        }
                        alt={item.name}
                        className="cart-img"
                      />
                    </Col>

                    <Col md={7} className="col-8">
                      <Card.Body>

                        <Card.Title
                          style={{ fontSize: "15px", fontWeight: "bold" }}
                        >
                          {item.name}
                        </Card.Title>

                        <Card.Text
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "green"
                          }}
                        >
                          In Stock
                        </Card.Text>

                        <h6 className="text-muted">
                          ₹ {item.price}
                          <span className="old-price ms-2">
                            mrp ₹ {item.mrp}
                          </span>
                        </h6>

                        <div className="qty-controls mt-3">
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => decreaseQty(item.id)}
                          >
                            -
                          </Button>

                          <span className="mx-3">{item.quantity}</span>

                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => increaseQty(item.id)}
                          >
                            +
                          </Button>
                        </div>

                      </Card.Body>
                    </Col>

                    <Col md={3} className="text-end pe-3 col-2">
                      <h6 style={{ fontWeight: "bold" }}>
                        ₹ {item.price * item.quantity}
                      </h6>

                      <Button
                        variant="link"
                        className="text-danger p-0"
                        onClick={() => removeItem(item.id)}
                      >
                        <Trash size={22} />
                      </Button>
                    </Col>

                  </Row>
                </Card>
              ))

            )}

          </Col>

          {/* RIGHT SIDE SUMMARY (HIDE IF CART EMPTY) */}
          {cartItems.length > 0 && (
            <Col md={3} className="mt-3">

              <Card className="p-3 summary-card">

                <h5 className="fw-bold mb-3 pb-2 border-bottom border-1">
                  Order Summary
                </h5>

                <div className="d-flex justify-content-between mb-2">
                  <span>Subtotal</span>
                  <span>₹ {subtotal}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                  <span>Shipping</span>
                  <span>{shipping === 0 ? "FREE" : `₹ ${shipping}`}</span>
                </div>

                {shipping === 0 ? (
                  <div className="text-success small">
                    🎉 You got free shipping
                  </div>
                ) : (
                  <>
                    <div className="text-muted small">
                      Free delivery on orders above ₹
                      {shippingSetting?.freeShippingAmount}
                    </div>

                    {shipping !== 0 && remaining > 0 && (
                      <div className="text-warning small">
                        Add ₹{remaining} more to get FREE delivery
                      </div>
                    )}
                  </>
                )}

                <div className="text-muted small mt-1">
                  Estimated delivery in {shippingSetting?.deliveryDays} days
                </div>

                <hr />

                <div className="d-flex justify-content-between fw-bold mb-3">
                  <span>Total ({itemcount} Items)</span>
                  <span>₹ {total}</span>
                </div>

                <Button
                  variant="dark"
                  className="w-100"
                  onClick={handleCheckout}
                >
                  Proceed to Checkout
                </Button>

              </Card>

            </Col>
          )}

        </Row>
      </Container>

      <Container style={{ marginBottom: "20px" }}></Container>

      <TopSelling />

      <Container className="my-5"></Container>
    </>
  );
};

export default Cart;